import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, setToken } from "@/lib/adminApi";
import { Lock, AlertCircle } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      setToken(data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1B1A] px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-[#F9F8F6] border-2 border-[#F26419] p-8 md:p-10"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[#2D5A3C] flex items-center justify-center">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#F26419]">Sustrai</p>
            <h1 className="font-display font-black text-2xl text-[#1A1B1A] leading-tight">Panel Admin</h1>
          </div>
        </div>

        {error && (
          <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 px-3 py-2 mb-5 text-sm">
            <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span>{String(error)}</span>
          </div>
        )}

        <label className="block text-xs tracking-[0.2em] uppercase font-bold text-[#5C635A] mb-2">Email</label>
        <input
          data-testid="admin-input-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-transparent border-0 border-b-2 border-[#D1D5DB] focus:border-[#2D5A3C] outline-none py-3 mb-5"
        />

        <label className="block text-xs tracking-[0.2em] uppercase font-bold text-[#5C635A] mb-2">Contraseña</label>
        <input
          data-testid="admin-input-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-transparent border-0 border-b-2 border-[#D1D5DB] focus:border-[#2D5A3C] outline-none py-3 mb-8"
        />

        <button
          type="submit"
          data-testid="admin-submit-btn"
          disabled={loading}
          className="w-full bg-[#F26419] hover:bg-[#D95512] disabled:opacity-60 text-white font-bold tracking-[0.1em] uppercase px-6 py-4 text-sm transition-colors"
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
